<template>
  <BootstrapDropdown class="ms-2">
    <template #toggle>
      <BootstrapButton
        name="view-select"
        variant="secondary"
        size="sm"
        class="w-100"
        data-bs-toggle="dropdown"
        aria-expanded="false"
        aria-label="Filter Lifecycles"
        data-testid="products-input-bar.button"
      >
        <Icon icon="material-symbols:repeat" class="me-2" />
        <span class="name">
          {{ selectedFilterLifecycle === '' ? 'Filter Lifecycles' : selectedFilterLifecycle }}
        </span>
      </BootstrapButton>
    </template>
    <template #items>
      <button
        v-for="option in lifecycleFilterOptions"
        :key="option.value"
        class="dropdown-item"
        @click="
          () => {
            emits('update-filter-lifecycle', option.value);
          }
        "
      >
        {{ option.label }}
      </button>
    </template>
  </BootstrapDropdown>
</template>

<script lang="ts" setup>
interface Props {
  selectedFilterLifecycle?: string;
}

const props = withDefaults(defineProps<Props>(), {
  selectedFilterLifecycle: '',
});

const emits = defineEmits<{
  (event: 'update-filter-lifecycle', newLifecycle: string): void;
}>();

const selectedFilterLifecycle = computed({
  get: () => props.selectedFilterLifecycle,
  set: (newLifecycle: string) => emits('update-filter-lifecycle', newLifecycle),
});

// constants
const lifecycleFilterOptions = [
  {label: 'Show All', value: ''},
  {label: 'Production', value: 'Production'},
  {label: 'In Development', value: 'In Development'},
  {label: 'End of Sale', value: 'End of Sale'},
  {label: 'End of Support', value: 'End of Support'},
  {label: 'End of Life', value: 'End of Life'},
];
</script>
